/* unplugin-vue-components disabled */import { render } from "./indexBottomCont.vue?vue&type=template&id=5b1cb889&scoped=true"
const script = {}

import "./indexBottomCont.vue?vue&type=style&index=0&id=5b1cb889&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1cb889"]])

export default __exports__